// extracted by mini-css-extract-plugin
module.exports = {"thumbprint":"style_thumbprint__3ADPE"};